import axios from 'axios';

import { Id, getData } from '@feature/utils';

import { Laboratory, LaboratoryInfoRequest, LaboratoryRequest } from './LaboratoryTypes';

export function getAll() {
  return axios.get<Laboratory[]>('/labs').then(getData);
}

export function getAllForCenter(centerId: Id) {
  return axios.get<Laboratory[]>(`/labs/for-center/${centerId}`).then(getData);
}

export function get(id: Id) {
  return axios.get<Laboratory>(`/labs/${id}`).then(getData);
}

export function edit(id: Id, request: LaboratoryRequest) {
  return axios.put<Laboratory>(`/labs/${id}`, request).then(getData);
}

export function create(request: LaboratoryRequest) {
  return axios.post<Laboratory>(`/labs`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/labs/${id}`).then(getData);
}

export function updateInfo(id: Id, request: LaboratoryInfoRequest) {
  return axios.put<unknown>(`/labs/${id}/info`, request).then(getData);
}
